import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import EntitySelectBox from '@components/EntitySelectBox'

import useCampaignCategories from '@hooks/useCampaignCategories'
import useCampaignCommercialCategories from '@hooks/useCampaignCommercialCategories'
import useCampaignRuralCategories from '@hooks/useCampaignRuralCategories'
import useCampaignSaleMethods from '@hooks/useCampaignSaleMethods'
import useCampaignTypes from '@hooks/useCampaignTypes'
import { useRelations } from '@hooks/useCampaign'

import InfoToolTip from '@components/InfoToolTip'

import type { CampaignModel, CampaignTypeModel } from '@models/types'

const getCategoryOptions = (campaignTypes: CampaignTypeModel[], entityState: Partial<CampaignModel>) => {
  const {
    campaign_category_id, campaign_commercial_category_id, campaign_rural_category_id, campaign_type_id,
  } = entityState

  const campaignType = campaignTypes.find(campaignType => campaignType.id === campaign_type_id)
  const { title } = campaignType || {}

  if (title === 'Rural'){
    return {
      entityKey: 'campaignRuralCategories',
      title: 'Rural Category',
      name: 'campaign_rural_category_id',
      value: campaign_rural_category_id,
    }
  }

  if (title === 'Commercial'){
    return {
      entityKey: 'campaignCommercialCategories',
      title: 'Commercial Category',
      name: 'campaign_commercial_category_id',
      value: campaign_commercial_category_id,
    }
  }

  return {
    entityKey: 'campaignCategories',
    title: 'Listing Category',
    name: 'campaign_category_id',
    value: campaign_category_id,
  }
}

interface ListingDetailsProps {
  campaignForm: UseFormPayload,
}

const ListingDetails = (props: ListingDetailsProps) => {
  const { campaignForm } = props

  useCampaignCategories({ performHttpRequests: true })
  useCampaignCommercialCategories({ performHttpRequests: true })
  useCampaignRuralCategories({ performHttpRequests: true })
  useCampaignSaleMethods({ performHttpRequests: true })

  const { filteredCampaignTypes } = useCampaignTypes({ performHttpRequests: true })

  const {
    entityState,
    entityState: {
      auction_date,
      campaign_sale_method_id,
      campaign_type_id,
      hide_price,
      price_guide,
      price,
      reserve_price,
    },
    handlers,
    setEntityState,
  } = campaignForm

  const categoryOptions = getCategoryOptions(filteredCampaignTypes, entityState)
  const {
    entityKey, name, title, value,
  } = categoryOptions

  const { campaignSaleMethod } = useRelations(entityState)

  return (
    <DashboardModule title="Listing Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Listing Type">
            <EntitySelectBox
              data-value-type="number"
              entityKey="campaignTypes"
              // @ts-expect-error TS2322
              name="campaign_type_id"
              value={campaign_type_id}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label={title} marginTop={['large', 0]}>
            <EntitySelectBox
              data-value-type="number"
              // @ts-expect-error TS2322
              disabled={!campaign_type_id}
              entityKey={entityKey}
              label={!campaign_type_id ? 'Select Listing Type' : 'Please Select'}
              name={name}
              value={campaign_type_id ? value : ''}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Row marginTop={[0, 'large']}>
          <Form.Field
            // @ts-expect-error TS2322
            label={(
              <>
                <Box marginRight="small">Price Guide</Box>

                <InfoToolTip>
                  Max 50 Characters. Portal sync will fail.
                </InfoToolTip>
              </>
            )}
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
          >
            <input
              name="price_guide"
              type="text"
              value={price_guide}
              {...handlers}
            />
          </Form.Field>
          <Form.Field
            direction="column"
            label="Reserve Price"
              // @ts-expect-error TS2322
            marginTop={['large', 0]}
          >
            <input
              min="0"
              name="reserve_price"
              type="number"
              value={reserve_price}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Row marginTop={[0, 'large']}>
          <Form.Field
            label="Price"
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
          >
            <input
              min="0"
              type="number"
              name="price"
              value={price}
              {...handlers}
            />
          </Form.Field>

          <Form.Field
            // @ts-expect-error TS2322
            label={(
              <>
                <Box marginRight="small">Price Hidden (Portals)</Box>

                <InfoToolTip>
                  Hides the price on portals e.g. realestate.com.au
                </InfoToolTip>
              </>
            )}
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
          >
            {/*
             // @ts-expect-error TS2322 */}
            <select
              data-value-type="boolean"
              name="hide_price"
              value={hide_price}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        {campaignSaleMethod?.title === 'Auction' && (
          <Form.Row marginTop="large">
            <Form.Field
              label="Sales/Listing Method"
              // @ts-expect-error TS2322
              marginTop={['large', 0]}
            >
              <EntitySelectBox
                data-value-type="number"
                entityKey="campaignSaleMethods"
                // @ts-expect-error TS2322
                name="campaign_sale_method_id"
                value={campaign_sale_method_id}
                {...handlers}
              />
            </Form.Field>
            <Form.Field direction="column" label="Auction Date">
              <input
                name="auction_date"
                {...handlers}
                onChange={e => setEntityState({ auction_date: e.target.value })}
                type="datetime-local"
                value={auction_date}
              />
            </Form.Field>

          </Form.Row>
        )}
      </Form>
    </DashboardModule>
  )
}

export default ListingDetails
